exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-input[data-v-34c9671c]{padding-top:40px}@media (max-width: 767px){.name-input[data-v-34c9671c]{padding-top:20px}}.pt50-sm[data-v-34c9671c]{padding-top:50px}@media (max-width: 767px){.pt50-sm[data-v-34c9671c]{padding-top:25px}}.stars-input:hover i[data-v-34c9671c]{color:#E8C900}.stars-input>i:hover ~ i[data-v-34c9671c]{color:black}\n", ""]);

// exports
